import { LoadingSpinner } from './Loading.styles';

export default () => <LoadingSpinner isFullScreen isLarge />;
